const resizeImage = (url, width, height, x, y, callback) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const imageObj = new Image();

    imageObj.crossOrigin = 'anonymous';

    canvas.width = width;
    canvas.height = height;

    imageObj.onload = () => {
        context.drawImage(imageObj, x, y, width, height, 0, 0, width, height);

        console.log(canvas);
        callback(canvas.toDataURL('image/png'));
    };

    imageObj.src = url;
};

export default resizeImage;
